import { sum } from '../shared/math'
import { entryNodeKey } from '../shared/keys'

const positionKey = entryNodeKey;

const indexByPositionAndMonth = (entries) => {
  const index = new Map();

  for (const entry of entries) {
    const indexKey = `${positionKey(entry)}|${entry.year}-${String(entry.month).padStart(2, '0')}`;
    if (!index.has(indexKey)) index.set(indexKey, []);
    index.get(indexKey).push(entry);
  }

  return index;
};

export const buildCategoryPositions = ({ estoquePecas, plano, realizado, monthKeys, currentMonthKey }) => {
  const stockByPosition = indexByPositionAndMonth(estoquePecas);
  const planByPosition = indexByPositionAndMonth(plano);
  const realizedByPosition = indexByPositionAndMonth(realizado);
  const positionIds = [...new Set(estoquePecas.map(positionKey))];

  return new Map(positionIds.map(positionId => {
    const positions = [];
    let carriedStock = null;

    monthKeys.forEach(key => {
      const stockEntries = stockByPosition.get(`${positionId}|${key}`) ?? [];
      const ideal = sum('idealInventoryUnits', stockEntries);

      if (key < currentMonthKey) {
        positions.push(null);
        carriedStock = ideal;
        return;
      }

      const initial = key === currentMonthKey
        ? sum('initialInventoryUnits', stockEntries)
        : carriedStock;
      const plannedSales = sum('unitsSold', planByPosition.get(`${positionId}|${key}`) ?? []);
      const realizedSales = sum('unitsSold', realizedByPosition.get(`${positionId}|${key}`) ?? []);
      const sales = plannedSales ?? realizedSales ?? 0;

      if (ideal == null || initial == null) {
        positions.push(null);
        carriedStock = ideal;
        return;
      }

      const final = initial + (sum('inboundInventoryUnits', stockEntries) ?? 0) - sales;

      positions.push({ initial, ideal, final });
      carriedStock = Math.max(final, ideal);
    });

    return [positionId, positions];
  }));
};

export const sumPositions = (categoryPositions, monthIndex, project) => {
  let total = null;

  for (const positions of categoryPositions.values()) {
    const position = positions[monthIndex];
    if (position) total = (total ?? 0) + project(position);
  }

  return total;
};